import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app.store";
import _ from "lodash";
import { getBranchList } from "./branch.api";
import { BranchModel, BranchState } from "./branch.models";

const currentBranchStorageName = "CurrentBranch";

const getCurrentBranchLocalStorage = () => {
  return localStorage.getItem(currentBranchStorageName);
};

const setCurrentBranchLocalStorage = (branchId: string) => {
  localStorage.setItem(currentBranchStorageName, branchId);
};

const removeCurrentBranchLocalStorage = () => {
  localStorage.removeItem(currentBranchStorageName);
};

export const fetchBranchList = createAsyncThunk(
  "branch/fetchBranchList",
  async (any, thunkApi) => {
    try {
      const res = await getBranchList();
      const branchId = getCurrentBranchLocalStorage();
      if (!_.isEmpty(branchId)) {
        const branch = res.data.find((m) => m.id === Number(branchId));
        if (branch) {
          thunkApi.dispatch(setCurrentBranch(branch));
        }
      } else if (res.data.length === 1) {
        thunkApi.dispatch(setCurrentBranch(res.data[0]));
      }
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }
);

export const branchSlice = createSlice({
  name: "branch",
  initialState: {
    currentBranch: {},
    branchList: [] as BranchModel[],
  } as BranchState,
  reducers: {
    setCurrentBranch: (state, action: PayloadAction<BranchModel>) => {
      setCurrentBranchLocalStorage(action.payload.id.toString());
      state.currentBranch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBranchList.fulfilled, (state, action) => {
      state.branchList = action.payload;
    });
  },
});
export const selectCurrentBranch = (state: RootState) => state.branch.currentBranch;
export const { setCurrentBranch } = branchSlice.actions;
